<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-3">
            <label>{{ $t('common_words.farm') }}</label>
            <br />
            <el-select
              clearable
              @change="showCalendar()"
              filterable
              class="select-primary custom-width-select required-farm shadow-sm"
              size="large"
              v-model="catchElaborateBoxesForm.farm_id"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="(option, index) in farms"
                class="select-primary"
                :value="option.id"
                :label="option.name"
                :key="index + option.id"
              ></el-option>
            </el-select>
          </div>
          <div
            class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3"
            v-if="isShowCalendar"
          >
            <label>{{ $t('common_words.calendar') }}</label>
            <br />
            <el-select
              clearable
              filterable
              class="select-primary custom-width-select required-calendar shadow-sm"
              size="large"
              v-model="catchElaborateBoxesForm.calendar_sel"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="(option, index) in calendars"
                class="select-primary"
                :value="option.id"
                :label="option.name"
                :key="index + option.id"
              ></el-option>
            </el-select>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
            <label>{{ $t('common_words.date') }}</label>
            <br />
            <el-date-picker
              v-if="renderComponent"
              :picker-options="pickerOptions"
              class="shadow-sm required-date"
              v-model="catchElaborateBoxesForm.date_sel"
              type="date"
              range-separator="-"
              :placeholder="`${$t('common_words.select2')}...`"
            >
            </el-date-picker>
          </div>
          <div class="col-12 col-md-5 col-xl-5 px-0">
            <label class="label-primary" style="color: transparent">{{
              $t('common_words.filter')
            }}</label
            ><br />
            <div class="display-btn-admin">
              <l-button
                wide
                type="info"
                class="btn-filter mb-0 mr-3"
                @click="validate"
              >
                {{ $t('common_words.generate') }}
              </l-button>
            </div>
          </div>
        </div>
        <br />
      </card>
      <div v-if="messageAlert" class="alert alert-warning" role="alert">
        {{ messageAlert }}
      </div>
      <card
        class="custom-shadow-card-header custom-table-responsive"
        :title="$t('production.crafted_boxes')"
        v-if="catchElaborateBoxes"
      >
        <div class="mt-4">
          <div class="row" v-if="isIndex() && (isCreate() || isUpdate())">
            <table
              aria-describedby="tabla-cajas-elaboradas"
              class="table table-striped table-bordered"
            >
              <thead>
                <tr class="cusmtom-thead-color">
                  <th scope="col" class="text-center p-3 custom-header-label">
                    {{ $t('production.boxes_mayus') }}
                  </th>
                  <th scope="col" class="text-center p-3 custom-header-label">
                    <strong>{{ $t('production.crafted_mayus') }}</strong>
                  </th>
                  <th scope="col" class="text-center p-3 custom-header-label">
                    <strong>{{ $t('production.rejected_mayus_2') }}</strong>
                  </th>
                  <th scope="col" class="text-center p-3 custom-header-label">
                    {{ $t('common_words.exported_mayus') }}
                  </th>
                  <th
                    v-if="!messageAlert"
                    scope="col"
                    class="text-center p-3 custom-header-label"
                  >
                    {{ $t('common_words.options_mayus') }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(p, i) in catchElaborateBoxesForm.nElaborates"
                  :key="i"
                >
                  <td class="text-center">
                    <el-select
                      clearable
                      filterable
                      width="10"
                      v-bind:class="`select-primary custom-width-select required-boxes shadow-sm ${
                        calculateTotalRow(i) < 0 ? `is-invalid` : ``
                      }`"
                      size="large"
                      v-model="catchElaborateBoxesForm.boxes_sel[i]"
                      :placeholder="`${$t('common_words.select')}...`"
                    >
                      <el-option
                        v-for="b in availableBoxes"
                        class="select-primary"
                        :value="b.id"
                        :label="`${b.code} - ${b.name}`"
                        :key="b.id"
                      ></el-option>
                    </el-select>
                  </td>
                  <td class="text-center">
                    <el-input
                      clearable
                      type="number"
                      min="0"
                      style="width: 110px"
                      v-bind:class="`shadow-sm text-center ${
                        calculateTotalRow(i) < 0 ? `is-invalid` : ``
                      }`"
                      @change="
                        verifyData(i, catchElaborateBoxesForm.number_boxes)
                      "
                      v-model="catchElaborateBoxesForm.number_boxes[i]"
                    />
                  </td>
                  <td class="text-center">
                    <el-input
                      clearable
                      type="number"
                      min="0"
                      style="width: 110px"
                      v-bind:class="`shadow-sm text-center ${
                        calculateTotalRow(i) < 0 ? `is-invalid` : ``
                      }`"
                      @change="
                        verifyData(
                          i,
                          catchElaborateBoxesForm.number_boxes_reject
                        )
                      "
                      v-model="catchElaborateBoxesForm.number_boxes_reject[i]"
                    />
                  </td>
                  <td class="text-center">
                    <h5 class="text-muted mt-3">
                      <strong>{{ calculateTotalRow(i) }}</strong>
                    </h5>
                  </td>
                  <td
                    v-if="!messageAlert"
                    class="text-center"
                    style="display: table-cell"
                  >
                    <div class="d-flex justify-content-center mt-3">
                      <a
                        v-if="isUpdate()"
                        v-tooltip.top-center="$t('common_words.add')"
                        class="btn-warning btn-simple btn-link custom-margin-actions"
                        @click.prevent="catchElaborateBoxesForm.nElaborates++"
                      >
                        <em class="fa fa-plus custom-size-fa-actions"></em>
                      </a>
                      <a
                        v-if="
                          catchElaborateBoxesForm.nElaborates > 1 && isDelete()
                        "
                        v-tooltip.top-center="$t('common_words.erase')"
                        class="btn-danger btn-simple btn-link custom-margin-actions"
                        @click="handleDelete(i)"
                      >
                        <em class="fa fa-times custom-size-fa-actions"></em>
                      </a>
                    </div>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <th scope="col" class="text-muted text-center">
                    {{ $t('production.boxes_total_mayus') }}
                  </th>
                  <td class="text-center">
                    <h5 class="text-muted mt-3">
                      <strong>{{ calculateTotalColumn(0) }}</strong>
                    </h5>
                  </td>
                  <td class="text-center">
                    <h5 class="text-muted mt-3">
                      <strong>{{ calculateTotalColumn(1) }}</strong>
                    </h5>
                  </td>
                  <td class="text-center">
                    <h5 class="text-muted mt-3">
                      <strong>{{ calculateTotalColumn(2) }}</strong>
                    </h5>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
          <div v-else>
            <br />
            <h5 class="text-muted text-center">
              {{ $t('common_words.no_permissions') }}
            </h5>
          </div>
          <div v-if="!messageAlert" class="row">
            <div class="col-6 text-right" v-if="isCreate() || isUpdate()">
              <l-button
                wide
                type="info"
                class="btn-filter m-4"
                @click="validateElaborate"
              >
                {{ $t('common_words.save') }}
              </l-button>
            </div>
            <div class="col-6 text-left" v-if="isDelete()">
              <l-button
                wide
                type="danger"
                class="btn-filter m-4"
                @click="confirmDelete"
              >
                {{ $t('common_words.delete') }}
              </l-button>
            </div>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import { Axios } from 'src/class/Axios.js';
import { mapActions } from 'vuex';
import { MixinNotification } from 'src/mixins/mixin-notification.js';
import { Pagination as LPagination } from 'src/components/index';
import configTable from './table';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import moment from 'moment';
import SweetAlert from 'src/class/Alerts';
import i18n from 'src/i18n';

export default {
  components: {
    LPagination,
  },

  computed: {
    ...configTable().Search,

    availableBoxes() {
      return this.boxes.filter(
        (box) => !this.catchElaborateBoxesForm.boxes_sel.includes(box.id)
      );
    },

    calendars() {
      if (this.catchElaborateBoxesForm.farm_id) {
        let calendars = [];
        this.farms.forEach((element) => {
          if (element.id == this.catchElaborateBoxesForm.farm_id) {
            calendars = element.calendars;
          }
        });

        return calendars;
      } else {
        return [];
      }
    },
  },

  data() {
    return {
      messageAlert: null,
      catchElaborateBoxesForm: {
        farm_id: null,
        date_sel: new Date(moment().format('YYYY-MM-DD').replace(/-/, '/')),
        nElaborates: 1,
        boxes_sel: [],
        number_boxes: [],
        number_boxes_reject: [],
        calendar_sel: null,
        user_id: this.$store.state.auth.user.id,
      },
      farms: [],
      catchElaborateBoxes: false,
      boxes: [],
      isShowCalendar: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      pagination: {},
      tableColumns: [],
      searchQuery: '',
      tableData: [],
      fuseSearch: null,
    };
  },

  mixins: [MixinPermissions, MixinNotification, mixinMasters, MixinMenu],
  watch: {
    '$i18n.locale': ['forceRerender', 'setupTable'],
  },

  methods: {
    ...mapActions({
      validationInputsRequired: 'utils/validationInputsRequired',
    }),

    showCalendar() {
      this.messageAlert = null;
      this.isShowCalendar = true;
      this.catchElaborateBoxesForm.calendar_sel = null;
      this.catchElaborateBoxes = false;

      const element = Object.values(this.farms).find(
        (el) => el.id === this.catchElaborateBoxesForm.farm_id
      );
      if (element) {
        this.isShowCalendar = element.calendars.length > 1;
        this.catchElaborateBoxesForm.calendar_sel =
          element.calendars.length > 1
            ? null
            : element.calendars.length == 1
            ? element.calendars[0].id
            : null;
      }

      this.isShowCalendar = false;
    },

    /**
     * Ejecuta las validaciones del formulario de reporte y confirma que
     * las reglas se cumplan para cargar la información solicitada
     */
    validate() {
      if (this.catchElaborateBoxesForm.farm_id == null)
        return this.validationInputsRequired('farm');
      else if (this.catchElaborateBoxesForm.date_sel == null)
        return this.validationInputsRequired('date');
      else if (this.catchElaborateBoxesForm.calendar_sel == null)
        SweetAlert.warning(i18n.t('common_words.no_associated_calendars'));
      else {
        this.messageAlert = null;
        this.cleanForm();
        this.loadElaborateBoxes();
      }
    },

    /**
     * Ejecuta las reglas y validaciones de la información registrada en la
     * tabla de cajas elaboradas, esperando que se cumplan para ejecutar la acción
     * de guardado o edición de los datos
     */
    validateElaborate() {
      if (
        this.catchElaborateBoxesForm.boxes_sel.length == 0 ||
        (this.catchElaborateBoxesForm.nElaborates > 0 &&
          this.catchElaborateBoxesForm.boxes_sel.length <
            this.catchElaborateBoxesForm.nElaborates)
      ) {
        return this.validationInputsRequired('boxes');
      } else {
        if (this.catchElaborateBoxesForm.number_boxes.length == 0) {
          SweetAlert.warning(i18n.t('sweet_alert.production.missing_fields'));
        } else {
          this.validateLinesElaborateBoxes()
            .then(() => {
              this.storeUpdateCatchsElaborateBoxes();
            })
            .catch((error) => {
              let msg = '';
              if (error < 0)
                msg = `${i18n.t('message.production.error_data_row')} ${
                  error * -1
                } ${i18n.t('message.production.check_info')}.`;
              else
                msg = `${i18n.t('message.production.check_table_info')} ${
                  error + 1
                }`;
              SweetAlert.warning(msg);
            });
        }
      }
    },

    /**
     * Válida línea por línea cada fila de la tabla de cajas elaboradas
     * verificando que los datos están registrados correctamente
     */
    async validateLinesElaborateBoxes() {
      return new Promise((resolve, reject) => {
        for (
          let index = 0;
          index < this.catchElaborateBoxesForm.nElaborates;
          index++
        ) {
          if (
            !this.catchElaborateBoxesForm.number_boxes[index] ||
            isNaN(parseInt(this.catchElaborateBoxesForm.number_boxes[index]))
          )
            reject(index);

          if (
            this.catchElaborateBoxesForm.number_boxes_reject[index] &&
            isNaN(
              parseInt(this.catchElaborateBoxesForm.number_boxes_reject[index])
            )
          ) {
            reject(index);
          }

          const totalRow =
            parseInt(this.catchElaborateBoxesForm.number_boxes[index]) -
            parseInt(this.catchElaborateBoxesForm.number_boxes_reject[index]);
          if (totalRow < 0) reject((index + 1) * -1);
        }

        resolve();
      });
    },

    confirmDelete() {
      if (this.catchElaborateBoxesForm.id) {
        SweetAlert.delete(
          i18n.t('sweet_alert.production.crafted_selected_box')
        ).then((result) => {
          if (result.value) this.deleteElaborateBoxes();
        });
      } else this.cleanForm();
    },

    deleteElaborateBoxes() {
      if (this.isDelete()) {
        this.showHideLoading(true);
        this.catchElaborateBoxesForm.route = 'boxes/catchs';
        Axios.destroyMaster(this.catchElaborateBoxesForm)
          .then((response) => {
            this.catchElaborateBoxes = false;
            this.cleanForm();
            this.showHideLoading();
            this.showNotification(
              i18n.t('common_words.capture_deleted'),
              'success',
              'nc-simple-remove',
              `${i18n.t('common_words.successful_deletion')}...`
            );
          })
          .catch((error) => {
            this.showHideLoading();
            this.showMessageErrors(error);
          });
      } else {
        this.showMessageAccess();
      }
    },

    /**
     * Guardar o actualizar la información de cajas elaboradas registrada en la tabla
     */
    storeUpdateCatchsElaborateBoxes() {
      this.showHideLoading(true);

      if (this.isCreate() || this.isUpdate()) {
        this.catchElaborateBoxesForm.route = 'boxes/catchs';
        this.catchElaborateBoxesForm.elaborate_box_date =
          this.catchElaborateBoxesForm.date_sel;

        if (this.catchElaborateBoxesForm.id) {
          Axios.updateMaster(this.catchElaborateBoxesForm)
            .then((response) => {
              this.showHideLoading();
              SweetAlert.success(response.data.message).then(() => {
                this.catchElaborateBoxes = false;
                this.cleanForm();
              });
            })
            .catch((error) => {
              this.showHideLoading();
              this.showMessageErrors(error);
            });
        } else {
          Axios.saveMaster(this.catchElaborateBoxesForm)
            .then((response) => {
              this.showHideLoading();
              SweetAlert.success(response.data.message).then(() => {
                this.catchElaborateBoxes = false;
                this.cleanForm();
              });
            })
            .catch((error) => {
              this.showHideLoading();
              this.showMessageErrors(error);
            });
        }
      } else {
        this.showMessageAccess();
        this.showHideLoading();
      }
    },

    /**
     * Limpia el formulario de la tabla a su estado inicial
     */
    cleanForm() {
      this.catchElaborateBoxesForm.nElaborates = 1;
      this.catchElaborateBoxesForm.boxes_sel = [];
      this.catchElaborateBoxesForm.number_boxes = [];
      this.catchElaborateBoxesForm.number_boxes_reject = [];
      delete this.catchElaborateBoxesForm.id;
    },

    /**
     * Método para eliminar línea de la tabla
     */
    handleDelete(index) {
      try {
        this.catchElaborateBoxesForm.number_boxes.splice(index, 1);
      } catch (error) {}

      try {
        this.catchElaborateBoxesForm.number_boxes_reject.splice(index, 1);
      } catch (error) {}

      try {
        this.catchElaborateBoxesForm.boxes_sel.splice(index, 1);
        let tmp = Object.assign([], this.catchElaborateBoxesForm.boxes_sel);
        this.catchElaborateBoxesForm.boxes_sel = [];
        setTimeout(() => {
          this.catchElaborateBoxesForm.boxes_sel = Object.assign([], tmp);
        }, 5);
      } catch (error) {}

      this.catchElaborateBoxesForm.nElaborates--;
    },

    /**
     * Método encargado de buscar la información al backend y cargar la
     * información si ya existe en la tabla de embolse
     */
    loadElaborateBoxes() {
      this.showHideLoading(true);
      this.catchElaborateBoxesForm.date_sel =
        this.catchElaborateBoxesForm.date_sel;
      let data = {
        route: 'boxes/catchs/indexspecified',
        farm_id: this.catchElaborateBoxesForm.farm_id,
        elaborate_box_date: moment(
          this.catchElaborateBoxesForm.date_sel
        ).format('Y-MM-DD'),
      };

      Promise.all([Axios.getMasters('boxes/boxes'), Axios.postMasters(data)])
        .then((response) => {
          const [response_boxes, response_data] = response;
          this.boxes = response_boxes.data.data;
          this.catchElaborateBoxes = true;

          if (response_data.data.data['closing']) {
            this.messageAlert = response_data.data.data['closing'].message;
          } else this.messageAlert = null;

          if (response_data.data.data[0]) {
            let editForm = response_data.data.data[0];
            this.catchElaborateBoxesForm.boxes_id = editForm.boxes_id;
            this.catchElaborateBoxesForm.id = editForm.id;
            this.catchElaborateBoxesForm.nElaborates = editForm.nElaborates;
            this.catchElaborateBoxesForm.number_boxes = editForm.number_boxes;
            this.catchElaborateBoxesForm.number_boxes_reject =
              editForm.number_boxes_reject;
            this.catchElaborateBoxesForm.calendar_sel = editForm.calendar_id;
            this.catchElaborateBoxesForm.user_id =
              this.$store.state.auth.user.id;

            try {
              this.catchElaborateBoxesForm.boxes_sel = [];
              setTimeout(() => {
                this.catchElaborateBoxesForm.boxes_sel = Object.assign(
                  [],
                  editForm.boxes_id
                );
              }, 5);
            } catch (error) {}
          } else {
            this.cleanForm();
          }

          this.showHideLoading();
        })
        .catch((error) => {
          console.log(error);
          this.cleanForm();
          this.showHideLoading();
          this.catchElaborateBoxes = false;
          if (error.response.data.message)
            SweetAlert.warning(error.response.data.message);
        });
    },

    /**
     * Verifica que el dato registrado sea
     * tipo entero definido y lo setea en la data
     * mencionada sobre el parametro type
     * @param index
     * @param type
     */
    verifyData(index, type) {
      if (isNaN(parseInt(type[index]))) {
        try {
          this.$set(type, index, null);
        } catch (error) {}
      }
    },

    calculateTotalRow(index) {
      let total =
        parseInt(
          this.catchElaborateBoxesForm.number_boxes[index]
            ? this.catchElaborateBoxesForm.number_boxes[index]
            : 0
        ) -
        parseInt(
          this.catchElaborateBoxesForm.number_boxes_reject[index]
            ? this.catchElaborateBoxesForm.number_boxes_reject[index]
            : 0
        );

      return total;
    },

    calculateTotalColumn(type) {
      let total = 0;
      let arraySum = [];
      switch (type) {
        case 0:
          arraySum = this.catchElaborateBoxesForm.number_boxes;
          break;
        case 1:
          arraySum = this.catchElaborateBoxesForm.number_boxes_reject;
          break;
        default:
          this.catchElaborateBoxesForm.number_boxes.forEach((element) => {
            total += parseInt(element ? element : 0);
          });

          this.catchElaborateBoxesForm.number_boxes_reject.forEach(
            (element) => {
              total -= parseInt(element ? element : 0);
            }
          );
          return total;
      }

      if (arraySum) {
        arraySum.forEach((element) => {
          const value = element ? element : 0;
          total += parseInt(value);
        });
      }

      return total;
    },
    setupTable() {
      const { Table } = configTable();
      this.tableColumns = Table.tableColumns;
      this.pagination = { ...Table.pagination };
    },
  },

  created() {
    if (this.isIndex()) {
      this.setupTable();
      this.showHideLoading(true);

      Promise.all([Axios.getMasters('farms/farms/onlyfruit')])
        .then((response) => {
          const [responseFarm] = response;
          this.farms = responseFarm.data.data;
          this.showHideLoading();
        })
        .catch((error) => {
          console.log(error);
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    this.selectedItemOnMenu('boxes');
  },

  destroyed() {
    this.deselectedItemOnMenu('boxes');
  },
};
</script>
<style>
.display-btn-admin {
  display: flex;
  align-content: center;
  flex-direction: row;
  align-items: center;
}
</style>
